<template>
  <div>
    <!-- 顶部区域 -->

    <div class="w w1200" style="margin-bottom: -30px">
      <div>
        <el-image class="buylogo" :src="require('@/assets/procurement/buylogo.png')">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="title">
          <h1>发起招标</h1>
        </div>
      </div>

      <!-- form表单 -->
      <div class="main-form">
        <!-- /////// upload///////// -->
        <div v-show="form.type != 1"
          style="display: flex;justify-content: flex-end;margin-right: 30px;position: relative;">
          <el-upload multiple action="fileUrl" :limit="1" accept=".xls,.xlsx,csv" :file-list="fileList"
            :before-upload="beforeUpload" :on-exceed="onExceed" :on-success="onSuccess" :show-file-list="true"
            :http-request="uploadFile">
            <el-button type="primary">导入模板</el-button>
          </el-upload>
        </div>
        <el-button v-show="form.type != 1" class="upload-btn download-btn" @click="download"
          type="warning">下载模板</el-button>
        <!-- ///// // upload///////// -->


        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="招标标题" class="main-form-item" label-width="140px" prop="title">
            <el-input maxlength="200" :disabled="type == 1" style="width: 367px" placeholder="请输入"
              v-model="form.title"></el-input>
          </el-form-item>

          <el-form-item label="项目名称" class="main-form-item" prop="projectName" label-width="140px">
            <el-input maxlength="200" :disabled="type == 1" style="width: 367px" placeholder="请输入"
              v-model="form.projectName"></el-input>
          </el-form-item>
          <div style="margin-top: 20px">
            <div class="main-flag">
              <b></b>
              <span>招标要求</span>
            </div>
          </div>
          <el-form-item label="招标类型" class="main-form-item" prop="type" label-width="140px">
            <el-radio-group v-model="form.type">
              <el-radio :label="1" :disabled="type == 1">标准产品采购</el-radio>
              <el-radio :label="2" :disabled="type == 1">施工分包</el-radio>
              <el-radio :label="3" :disabled="type == 1">劳务分包</el-radio>
              <el-radio :label="4" :disabled="type == 1">服务分包</el-radio>
              <el-radio :label="5" :disabled="type == 1">其他</el-radio>
            </el-radio-group>
          </el-form-item>

          <div>
            <div style="margin: 0 40px">
              <el-table v-if="form.type == 1" class="tableStyle" :data="form.detailsList" border key="tables"
                style="width: 100%">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column label="产品名称" width="150px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.productName`" :rules="rules.productName">
                      <span v-if="type == 1">{{ scope.row.productName }}</span>
                      <el-input maxlength="12" v-if="type == 0 || type == 2 || type == 4" filterable allow-create
                        default-first-option v-model="scope.row.productName" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="规格型号" width="120px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.spec`" :rules="rules.spec">
                      <span v-if="type == 1">{{ scope.row.spec }}</span>
                      <el-input v-if="type == 0 || type == 2 || type == 4" filterable maxlength="8" allow-create
                        default-first-option v-model="scope.row.spec" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.spec`" :rules="rules.spec">
                      <span v-if="type == 1">{{ scope.row.brand }}</span>
                      <el-input maxlength="10" v-if="type == 0 || type == 2 || type == 4" filterable allow-create
                        default-first-option v-model="scope.row.brand" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发货时效(天)" width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.deliverDays`" :rules="rules.deliverDays">
                      <span v-if="type == 1">{{ scope.row.deliverDays }}</span>
                      <!-- onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" -->
                      <el-input maxlength="4" v-if="type == 0 || type == 2 || type == 4" filterable allow-create
                        default-first-option v-model="scope.row.deliverDays" placeholder="请输入"></el-input>
                      <!-- <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-if="type == 0 || type == 2 || type == 4"
                        v-model="scope.row.deliverDays"
                        type="date"
                        placeholder="选择日期"
                      >
                      </el-date-picker> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="技术参数要求" width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.technicalRqmts`" :rules="rules.technicalRqmts">
                      <span v-if="type == 1">{{
                        scope.row.technicalRqmts
                      }}</span>
                      <el-input maxlength="8" v-if="type == 0 || type == 2 || type == 4" filterable allow-create
                        default-first-option v-model="scope.row.technicalRqmts" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="单位" width="60px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.unit`" :rules="rules.unit">
                      <span v-if="type == 1">{{ scope.row.unit }}</span>
                      <el-input v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.unit" placeholder="请输入" maxlength="4"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="80px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.number`" :rules="rules.number">
                      <span v-if="type == 1">{{ scope.row.number }}</span>
                      <el-input @input="
                        priceChange(scope.row.number, scope.row.priceLimit)
                      " v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.number" placeholder="请输入" maxlength="4"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="上限价格(￥)" width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList.${scope.$index}.priceLimit`" :rules="rules.priceLimit">
                      <span v-if="type == 1">{{ scope.row.priceLimit }}</span>
                      <el-input
                        onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                        @input="
                          priceChange(scope.row.number, scope.row.priceLimit)
                        " v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.priceLimit" placeholder="请输入" maxlength="4"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="100px">
                  <template slot-scope="scope">
                    <span v-if="type == 1">{{ scope.row.remark }}</span>
                    <el-input v-if="type == 0 || type == 2 || type == 4" placeholder="请输入备注" type="textarea"
                      maxlength="50" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="operation" label="操作" align="center" width="100">
                  <template slot-scope="scope">
                    <span v-if="type == 1">--</span>
                    <el-button v-if="type == 0 || type == 2 || type == 4" type="danger"
                      @click="handleDelete(scope.$index, scope.row, 1)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- {{ form.detailsList2 }} -->
              <el-table v-if="form.type == 2 || form.type == 3 || form.type == 4 || form.type == 5" class="tableStyle"
                :data="form.detailsList2" border key="tables2" style="width: 100%">
                <!-- ///////////////////////////////// -->
                <el-table-column type="index" label="序号" width="50px">
                </el-table-column>
                <el-table-column label="项目名称" min-width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList2.${scope.$index}.projectName`" :rules="rules2.projectName">
                      <span v-if="type == 1">{{ scope.row.projectName }}</span>
                      <el-input maxlength="12" v-if="type == 0 || type == 2 || type == 4" filterable allow-create
                        default-first-option v-model="scope.row.projectName" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="workDescs" label="工作描述" min-width="100px">
                  <template slot-scope="scope">
                    <span v-if="type == 1">{{ scope.row.workDescs }}</span>
                    <el-input v-else placeholder="请输入工作事项描述" type="textarea" maxlength="50"
                      v-model="scope.row.workDescs"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="计量单位" min-width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList2.${scope.$index}.calculateUnit`" :rules="rules2.calculateUnit">
                      <span v-if="type == 1">{{ scope.row.calculateUnit }}</span>
                      <el-input v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.calculateUnit" placeholder="请输入" maxlength="4"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="工程量" min-width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList2.${scope.$index}.quantities`" :rules="rules2.quantities">
                      <span v-if="type == 1">{{ scope.row.quantities }}</span>
                      <el-input
                        onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                        @input="
                          priceChange2(scope.row)
                        " v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.quantities" placeholder="请输入" maxlength="10"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="品牌-型号" min-width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="`detailsList2.${scope.$index}.brandAndModel`" :rules="rules2.brandAndModel">
                      <span v-if="type == 1">{{ scope.row.brandAndModel }}</span>
                      <el-input v-if="type == 0 || type == 2 || type == 4" filterable allow-create default-first-option
                        v-model="scope.row.brandAndModel" placeholder="请输入" maxlength="10"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

<!--       更改内容         -->
                 <el-table-column label="设备材料单价" min-width="120px">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`detailsList2.${scope.$index}.stuffPrice`"
                    >
                      <span v-if="type == 1">{{ scope.row.stuffPrice }}</span>
                      <el-input
                        onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                        @input="
                          priceChange2(scope.row)
                        "
                        v-if="type == 0 || type == 2 || type == 4"
                        filterable
                        allow-create
                        default-first-option
                        v-model="scope.row.stuffPrice"
                        placeholder="请输入"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                 <el-table-column label="人工单价" min-width="80px">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`detailsList2.${scope.$index}.manMadePrice`"
                    >
                      <span v-if="type == 1">{{ scope.row.manMadePrice }}</span>
                      <el-input
                        onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                        @input="
                          priceChange2(scope.row)
                        "
                        v-if="type == 0 || type == 2 || type == 4"
                        filterable
                        allow-create
                        default-first-option
                        v-model="scope.row.manMadePrice"
                        placeholder="请输入"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                 <el-table-column label="综合单价" min-width="80px">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`detailsList2.${scope.$index}.synthesizePrice`"
                    >
                      <span v-if="type == 1">{{ scope.row.synthesizePrice }}</span>
                      <el-input
                        disabled
                        v-if="type == 0 || type == 2 || type == 4"
                        filterable
                        allow-create
                        default-first-option
                        v-model="scope.row.synthesizePrice"
                         maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                 <el-table-column label="合价" min-width="80px">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`detailsList2.${scope.$index}.allPrice`"
                    >
                      <span v-if="type == 1">{{ scope.row.allPrice }}</span>
                      <el-input
                        disabled
                        v-if="type == 0 || type == 2 || type == 4"
                        filterable
                        allow-create
                        default-first-option
                        v-model="scope.row.allPrice"
                         maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
<!--       更改内容         -->

                <el-table-column prop="remark" label="备注" min-width="100px">
                  <template slot-scope="scope">
                    <span v-if="type == 1">{{ scope.row.remark }}</span>
                    <el-input v-if="type == 0 || type == 2 || type == 4" placeholder="请输入备注" type="textarea"
                      maxlength="50" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="operation" label="操作" align="center" width="100">
                  <template slot-scope="scope">
                    <el-button v-if="type == 0 || type == 2 || type == 4" type="danger"
                      @click="handleDelete(scope.$index, scope.row, 2)">删除</el-button>
                  </template>
                </el-table-column>
                <!-- /////////////////////////////////// -->

              </el-table>
              <div style="background: #e3e8f3">
                <div style="
                      margin: auto;
                      width: 60px;
                      height: 30px;
                      line-height: 30px;
                    ">
                  <a style="text-align: center; color: #5b8bff" @click="add()">+新增一行</a>
                </div>
              </div>

              <div class="coumputed-price" style="margin-bottom: 20px" v-if="form.ProcurementType === '现货/标准品'">
                <p>
                  数量总计: <span>2</span>
                  件
                </p>
              </div>
            </div>
          </div>
          <!-- 商务要求 -->
          <div style="margin-top: 20px">

            <el-form-item label="招标方式" class="main-form-item" prop="visible" label-width="140px"
              v-if="type == 1 || type == 2 || type == 4">
              <el-radio-group v-model="form.visible" @change="handlevisible()">
                <el-radio :disabled="type == 1 || type == 2 || type == 4" :label="1">所有供应商可见</el-radio>
                <el-radio :disabled="type == 1 || type == 2 || type == 4" :label="2">指定供应商可见
                </el-radio>

              </el-radio-group>
            </el-form-item>
            <el-form-item label="招标方式" class="main-form-item" prop="visible" label-width="140px" v-else>
              <el-radio-group v-model="form.visible" @change="handlevisible()">
                <el-radio :disabled="type == 1 || type == 2" :label="1">所有供应商可见</el-radio>
                <el-radio :disabled="type == 1 || type == 2" :label="2">指定供应商可见
                </el-radio>
                <el-select multiple filterable v-model="form.supplierIdList" placeholder="请选择" v-if="form.visible == 2">
                  <el-option v-for="item in optionstype" :key="item.bxmId" :label="item.name" :value="item.bxmId">
                  </el-option>
                </el-select>

              </el-radio-group>
            </el-form-item>
            <el-form-item label="报价截止日期" class="main-form-item" prop="quoteEndTime" label-width="140px">
              <el-date-picker :disabled="type == 1" v-model="form.quoteEndTime" type="datetime" style="width: 367px"
                value-format="yyyy-MM-dd HH:mm:ss" placeholder="请输入日期" default-time="23:59:59">
              </el-date-picker>
            </el-form-item>
            <div style="margin-top: 20px">
              <div class="main-flag">
                <b></b>
                <span>商务要求</span>
              </div>
              <el-form-item label="送货地址" class="main-form-item rigth" label-width="140px" prop="address">
                <el-cascader :disabled="type == 1" style="width: 367px" v-model="invoiceAddressValue" ref="area"
                  class="projectAddress" placeholder="请输入地址" :props="{ checkStrictly: true }" :options="getprovince"
                  @change="invoiceAreaChange">
                </el-cascader>
              </el-form-item>
              <el-form-item label="招标对接人" class="main-form-item" label-width="140px" prop="contactPerson">
                <el-input :disabled="type == 1" v-model="form.contactPerson" style="width: 367px" maxlength="10"
                  placeholder="请输入联系人"></el-input>
              </el-form-item>
              <el-form-item label="招标对接联系方式" class="main-form-item" label-width="140px" prop="phone">
                <el-input :disabled="type == 1" v-model="form.phone" style="width: 367px" maxlength="11"
                  placeholder="请输入联系方式"></el-input>
              </el-form-item>
              <el-form-item v-if="form.type == 1" label="项目总金额" class="main-form-item" label-width="140px" prop="desc">
                <el-input :disabled="true" style="width: 367px" placeholder="" v-model="total"></el-input>
              </el-form-item>
              <el-form-item label="补充说明" class="main-form-item" label-width="140px" prop="desc">
                <el-input :disabled="type == 1" style="width: 367px" placeholder="请输入您对供应商的要求、物流配送要求、等信息" type="textarea"
                  v-model="form.desc"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-row>
            <el-upload :disabled="type == 1" name="files" class="upload-demo"
              :action="`${$baseUrl}/custom/xunyou/api/common/upload`" :on-success="handleAvatarSuccess"
              :show-file-list="false" :before-upload="beforeAvatarUpload">
              <!-- <img :src="urlImg" class="avatar" /> -->
              <el-button size="small" type="text"><i class="el-icon-upload2"></i>上传文件</el-button>
              <span slot="tip" class="el-upload__tip">
                例:
                产品规格书、样品图等（支持jpg、doc、excel、zip等格式）；每个附件最大10M，附件超出10M，请对附件进行压缩或附件内容截图、拍照后上传。
              </span>
            </el-upload>
          </el-row>
          <div>
            <div class="read" v-if="type == 0 || type == 2 || type == 4">
              <el-radio v-model="agree" label="1">阅读并同意
                <router-link to="/PurchaseAgreement" style="color: #5b8bff">
                  《辰安天泽平台报价协议》</router-link></el-radio>
            </div>
            <div v-if="type == 0 || type == 2 || type == 4" style="margin-left: auto;
                  margin-right: auto;
                  width: 600px;
                  padding-bottom: 10px;
                  margin-top: 20px;
                  text-align: center;
                ">
              <el-button type="success" @click="handleSubmit('form')" class="submit-button">提交</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 底部 -->
    <el-footer>
      <footernav></footernav>
    </el-footer>
  </div>
</template>
<script>
import footernav from "../../components/footernav.vue";
import {
  releaseAdd,
  releaseDetails,
  releaseUpdate,
  getPurchaseAgreement,
  detailsForSupplier,
  supplierList,
} from "@/api/xunyou";
import { mapState } from "vuex";
import Pagination from "../../components/Pagination";
import Axios from "axios";
import { login } from "../../api/userMG";

export default {
  data() {
    return {
      fileList: [], //文件列表
      agree: "0",
      urlImg: "",
      type: 0,
      qid: "",
      optionstype: [],
      loading: true,
      accountStatus: JSON.parse(localStorage.getItem("userdata")).accountStatus,
      total: "",
      form: {
        supplierIdList: [], //采购方式为2时选择的供应商ids,多个以英文逗号分隔
        userId: JSON.parse(localStorage.getItem("userdata")).userId,
        projectName: "",
        title: "",
        type: 1,
        mid: "",
        visible: 1,
        quoteEndTime: "",
        address: "",
        contactPerson: "",
        phone: "",
        attachment: "",
        province: "",
        city: "",
        area: "",
        detailsList: [],
        detailsList2: [],
      },
      form2: {
        number: '', //序号
        projectName: "", //项目名称
        workDescs: "", //工作描述
        calculateUnit: "", //计量单位
        quantities: "", //工程量
        brandAndModel: "", //品牌-型号
        stuffPrice: "", //设备材料单价
        manMadePrice: "", // 人工单价
        synthesizePrice: "", // 综合单价
        allPrice: "", // 合价
        remark: "", // 备注

      },
      rules: {
        title: [{ required: true, message: "请输入采购标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择采购类型", trigger: "blur" }],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        visible: [
          { required: true, message: "请选择采购方式", trigger: "blur" },
        ],
        quoteEndTime: [
          { required: true, message: "请填写日期", trigger: "blur" },
        ],
        amount: [{ required: true, message: "必填", trigger: "blur" }],

        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入类型方式", trigger: "blur" }],
        address: [
          { required: true, message: "请选择送获地址", trigger: "blur" },
        ],
        number: [{ required: true, message: "必填", trigger: "blur" }],
        productName: [{ required: true, message: "必填", trigger: "blur" }],
        priceLimit: [{ required: true, message: "必填", trigger: "blur" }],
        spec: [{ required: true, message: "必填", trigger: "blur" }],
        technicalRqmts: [{ required: true, message: "必填", trigger: "blur" }],
        unit: [{ required: true, message: "必填", trigger: "blur" }],
      },
      rules2: {
        projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        calculateUnit: [{ required: true, message: "请输入计量单位", trigger: "blur" }],
        quantities: [
          { required: true, message: "请输入工程量", trigger: "blur" },
        ],
        brandAndModel: [
          { required: true, message: "请输入品牌型号", trigger: "blur" },
        ],
        stuffPrice: [
          { required: true, message: "请输入设备材料", trigger: "blur" },
        ],
        manMadePrice: [{ required: true, message: "人工单价", trigger: "blur" }],

        synthesizePrice: [
          { required: true, message: "请输入综合单价", trigger: "blur" },
        ],
        allPrice: [{ required: true, message: "请输入合价", trigger: "blur" }],
      },
      invoiceAddressValue: [],
      area: "",
      options: [],
      type: JSON.parse(localStorage.getItem("userdata")).type, //1-供应商，3-采购商
    };
  },
  computed: {
    ...mapState(["getprovince"]),
  },
  //  watch: {
  //   $route(n, o) {
  //     console.log(n.fullPath,o.fullPath);
  //     if (n.fullPath !== o.fullPath) {

  //      //methods中封装的加载数据函数
  //     }
  //   },
  // },
  created() {
    this.qid = this.$route.query.purchaseOrderId;
    this.type = this.$route.query.type == null ? 0 : this.$route.query.type;
  },
  mounted() {

    this.handelData();


  },
  components: { Pagination, footernav },
  methods: {
    priceChange2(item) {
      item.synthesizePrice = Number(item.stuffPrice) + Number(item.manMadePrice)
      item.allPrice = item.synthesizePrice * Number(item.quantities)
      console.log("item", item);

    },
    download() {
      const a = document.createElement('a');
      a.href = this.$baseUrl + '/custom/purchase/order/api/exportDetails'
      a.download = "模板.xlsx"
      a.click()
    },
    //文件上传之前的钩子,可以做一些验证或限制
    beforeUpload(file) {
      this.fileList = []
      console.log('beforeUpload', file);
      let regExp = file.name.replace(/.+\./, '');
      let lower = regExp.toLowerCase(); //把大写字符串全部转为小写字符串
      let suffix = ['xls', 'xlsx'];
      if (suffix.indexOf(lower) === -1) {
        return this.$message.warning('请上传后缀名为 xls、xlsx 的附件 !');
      }
      let isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        return this.$message.error('请上传文件大小不能超过 2MB 的附件 !');
      }
    },
    //文件超出个数限制时的钩子
    onExceed(files, fileList) {
      console.log('onExceed-files', files);
      console.log('onExceed-fileList', fileList);
      return this.$message.warning(`只能选择1个文件,当前共选择了${files.length + fileList.length}个`)
    },
    //文件上传成功时的钩子
    onSuccess(response, file, fileList) {
      console.log('onSuccess', response);
      console.log('onSuccess', file);
      console.log('onSuccess', response);
    },
    //覆盖默认的上传行为,可以自定义上传的实现
    uploadFile(item) {

      let formData = new FormData();
      formData.append('file', item.file);
      //请求接口
      this.$axios.post(this.$baseUrl + '/custom/purchase/order/api/importDetails', formData).then((res) => {
        console.log("上传res", res);
        if (res.data.code == 0) {
          this.form.detailsList2 = res.data.data
          this.$message.success(res.data.msg);
        }
      })
    },

    //调取协议
    handleAgreement() {
      getPurchaseAgreement().then(() => { });
    },
    //计算合计
    priceChange(price) {
      let totals = 0;
      this.form.detailsList.forEach((item, index) => {
        let totalPrice =
          (item.priceLimit == null ? 0 : item.priceLimit) * item.number;
        totals += Number(totalPrice);
      });

      this.total = totals.toFixed(2);
    },
    //查询数据
    handelData() {
      this.loading = false;
      detailsForSupplier({ purchaseOrderId: this.qid }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          if (res.data.length !== 0) {
            this.form = res.data;
            this.form.province = res.data.province;
            this.form.city = res.data.city;
            this.form.area = res.data.area;
            this.total = res.data.total;
            this.form.detailsList2 = res.data.detailsList
            const list = [];
            if (
              (this.form.area !== "") &
              (this.form.city !== "") &
              (this.form.province !== "")
            ) {
              list.push(
                Number(this.form.province),
                Number(this.form.city),
                Number(this.form.area)
              );
            } else if ((this.form.area == "") & (this.form.city !== "")) {
              list.push(Number(this.form.province), Number(this.form.city));
            } else if ((this.form.area == "") & (this.form.city == "")) {
              list.push(Number(this.form.province));
            }
            console.log(list, "list");
            this.invoiceAddressValue = list; //回显地区
            this.form.detailsList = res.data.detailsList; //回显全部内容
          } else {
            this.form = {};
          }
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.form.attachment = res.url;
      this.urlImg = URL.createObjectURL(file.raw);
      this.$message.success("上传成功!");
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
      return isLt2M;
    },
    // 公司地址选择

    invoiceAreaChange(value) {
      this.form.address = String(
        this.$refs["area"].getCheckedNodes()[0].pathLabels
      ).replace(/,/g, "");

      if (value.length == 1) {
        this.form.province = value[0];
      } else if (value.length == 2) {
        this.form.province = value[0];
        this.form.city = value[1];
      } else if (value.length == 3) {
        this.form.province = value[0];
        this.form.city = value[1];
        this.form.area = value[2];
      }
    },
    //查询指定供应商数据
    handlevisible() {
      supplierList({ pageNum: 1, pageSize: 100 }).then((res) => {
        this.optionstype = res.rows;
      });
    },
    //添加一行
    add() {
      if (this.type !== "1") {
        if (this.form.type == 1) {
          this.form.detailsList.push({
            index: this.form.detailsList.length,
            productName: "",
            spec: "",
            technicalRqmts: "",
            unit: "",
            number: "",
            priceLimit: "",
            remark: "",
            service: "",
            servicePeriod: "",
            workDesc: "",
          });
        } else {
          this.form.detailsList2.push({
            projectName: "", //项目名称
            workDescs: "", //工作描述
            calculateUnit: "", //计量单位
            quantities: "", //工程量
            brandAndModel: "", //品牌-型号
            stuffPrice: "", //设备材料单价
            manMadePrice: "", // 人工单价
            synthesizePrice: "", // 综合单价
            allPrice: "", // 合价
            remark: "", // 备注

          });
        }

      }
    },
    // 删除操作
    handleDelete(id, row, type) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          if (type == 1) {
            if (this.form.detailsList.length !== 0) {
              this.form.detailsList.splice(id, 1);
            }
          } else {
            if (this.form.detailsList2.length !== 0) {
              this.form.detailsList2.splice(id, 1);
            }
          }
          this.$message.success("删除成功");

        })
        .catch(() => { });
    },
    //提交
    handleSubmit(form) {
      if (this.accountStatus == 1) {
        //控制账户是否禁用
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.agree !== "0") {
              //是否同意协议
              if (this.form.type == 1 ? this.form.detailsList.length !== 0 : this.form.detailsList2.length !== 0) {
                //表格里数据

                if (this.type == 0 || this.type == 4) {
                  //新增
                  if (this.form.type != 1) {
                    this.form.detailsList = this.form.detailsList2
                    this.form.detailsList.forEach((item) => {
                      delete item.number
                    })
                  }
                  releaseAdd(this.form).then((res) => {
                    if (res.code == 0) {
                      this.$message({
                        type: "success",
                        message: "提交成功",
                      });
                      this.$router.push("/mypurchase");
                    }
                  });
                } else if (this.type == 2) {
                  //修改
                  if (this.form.type != 1) {
                    this.form.detailsList = this.form.detailsList2
                    this.form.detailsList.forEach((item) => {
                      delete item.number
                    })
                  }
                  releaseUpdate(this.form).then((res) => {
                    if (res.code == 0) {
                      this.$message({
                        type: "success",
                        message: "修改成功",
                      });
                      this.$router.push("/mypurchase");
                    }
                  });
                }
              } else {
                this.$message({
                  type: "info",
                  message: "请填写表格里的内容",
                });
              }
            } else {
              this.$message({
                type: "info",
                message: "请先同意协议",
              });
            }
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用，不可以发起采购",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.upload-btn {
  position: absolute;
  right: 30px;
  z-index: 10;
}

.download-btn {
  margin-top: 50px;
}

/deep/ .el-date-editor {
  position: relative;

  .el-input__prefix {
    display: none;
  }
}

.star div::after {
  content: "*";
  color: red;
}

.buylogo {
  margin-top: 10px;
  width: 100%;
}

.title {
  padding: 24px 0 46px 0;
  background: #fff;
}

.title p {
  float: right;
  line-height: 20px;
  padding-right: 22px;
  margin: 0;
  font-size: 19px;
  font-weight: bold;
  text-align: right;
}

.title p a {
  line-height: 23px;
  font-size: 16px;
  color: #272727;
}

a {
  text-decoration: none;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.title h1 {
  margin: 0;
  text-align: center;
  font-size: 20px;
}

.main-form {
  position: relative;
  background: #fff;

  .main-flag {
    margin-bottom: 20px;
    margin-left: 20px;

    b {
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #c6523f;
      vertical-align: middle;
    }

    span {
      padding-left: 8px;
      vertical-align: middle;
    }
  }

  .main-form-item {
    margin-left: 40px;
  }

  /deep/.el-form-item__label {
    text-align: left !important;
  }
}

.listItems {
  margin-left: 20px;
  margin-right: 20px;
}

.product-template {
  margin-bottom: 20px;

  p {
    padding-left: 40px;
    font-size: 14px;
    color: #272727;
    line-height: 22px;
  }
}

.coumputed-price {
  padding: 12px;
  line-height: 30px;
  font-size: 14px;
  background: #f4f5fc;

  span {
    font-size: 18px;
    color: #c6523f;
  }
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ffffff;
  color: #666;
}

/deep/.page-box {
  margin: 20px 10px 0 65px;
}

.upload-demo {
  margin-left: 40px;

  .el-upload__tip {
    padding-left: 12px;
    line-height: 22px;
    color: #8d8d8d;
  }
}

.read {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 600px;
  padding-bottom: 10px;

  text-align: center;
}

.errors {
  color: #f56c6c;
  font-size: 12px;
  line-height: 2;
  margin-left: 30px;
  padding-top: 5px;
}

.submit-button {
  background: #c6523f;
  color: #fff;
  border: 1px solid #c6523f;
  width: 126px;
  font-weight: 400;
}

.savedrafts-button {
  width: 126px;
  border: 1px solid #c6523f;
  background: #ffefec;
  color: #c6523f;
  font-weight: 400;
}

/deep/.el-input__inner {
  background-color: #fff;
}

.tableStyle /deep/.el-input__inner {
  border: none !important;
  font-size: 12px;
  padding: 0 !important;
  margin: 0;
}

.tableStyle /deep/.el-textarea__inner {
  border: none;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: hidden;
}

.edit-inquiry-type {
  color: #fe7045;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  position: absolute;
  top: 15px;

  right: 100px;
}
v-deep.cancel{
  margin-top: 0;
}
</style>
<style>
.el-time-panel .cancel{
  margin-top: 0!important;
}</style>



// WEBPACK FOOTER //
// src/views/RapidProcurement/index.vue